import { createSlice } from '@reduxjs/toolkit'
import { getRoomConfig } from './livekitThunks'
import { mapSocketFactory } from '../../../../utils/socketFactory'

const initialState = {
  livekitMicActive: false,
  livekitSpeakerActive: false,
  livekitCameraActive: false,
  livekitScreenShareActive: false,
  livekitToken: null,
  connectionQuality: "",
  error: null,
  zoomedTrackId: null,
  videoCount: 0,
  livekitTranscriptionActive: false,
  conferenceMode: false,
  pinnedTrackId: null,
  isFullScreen: false,
  stopedCameraTracks: {},
}


const livekitSlice = createSlice({
  name: 'livekit',
  initialState,
  reducers: {
    toggleLivekitMic: (state, action) => {
      state.livekitMicActive = !!action.payload
    },
    toggleLivekitSpeaker: (state, action) => {
      state.livekitSpeakerActive = !!action.payload
    },
    toggleLivekitCamera: (state, action) => {
      state.livekitCameraActive = !!action.payload
    },
    toggleLivekitScreenShare: (state, action) => {
      state.livekitScreenShareActive = !!action.payload
    },
    setConnectionQuality: (state, action) => {
      state.connectionQuality = action.payload
    },

    setStopedCameraTracks: (state, action) => {
      const { email, trackSid } = action.payload;
      if (email && trackSid) {
        state.stopedCameraTracks = {
          ...state.stopedCameraTracks,
          [email]: trackSid,
        };
      }
    },

    restoreCameraTrack: (state, action) => {
      const email = action.payload;
      if (email && state.stopedCameraTracks[email]) {
        delete state.stopedCameraTracks[email];
      }
    },
    restoreCameraTrackBySid: (state, action) => {
      const trackSid = action.payload;
      const emailToDelete = Object.keys(state.stopedCameraTracks).find(
        email => state.stopedCameraTracks[email] === trackSid
      );

      if (emailToDelete) {
        delete state.stopedCameraTracks[emailToDelete];
      }
    },

    setIsFullScreen: (state, action) => {
      state.isFullScreen = action.payload
    },
    setZoomedMediaId: (state, action) => {
      state.zoomedTrackId = action.payload
    },
    setPinnedTrackId: (state, action) => {
      state.pinnedTrackId = action.payload
    },
    incrementVideoCount: (state, action) => {
      state.videoCount++
    },
    decrementVideoCount: (state, action) => {
      state.videoCount--
    },
    toggleLivekitTranscription: (state, action) => {
      state.livekitTranscriptionActive = !!action.payload
    },
    setViewMode: (state, action) => {
      state.conferenceMode = action.payload
    },
    toggleConferenceMode: (state) => {
      state.conferenceMode = !state.conferenceMode;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRoomConfig.fulfilled, (state, action) => {
        state.livekitToken = action.payload.refreshToken
      })
      .addCase(getRoomConfig.rejected, (state, action) => {
        state.livekitToken = null
        state.error = action.payload
      })
  },
})

export const {
  toggleLivekitMic,
  toggleLivekitSpeaker,
  toggleLivekitCamera,
  toggleLivekitScreenShare,
  setConnectionQuality,
  setZoomedMediaId,
  setPinnedTrackId,
  incrementVideoCount,
  decrementVideoCount,
  toggleLivekitTranscription,
  setViewMode,
  toggleConferenceMode,
  setConferenceMode,
  setStopedCameraTracks,
  restoreCameraTrack,
  setIsFullScreen,
  restoreCameraTrackBySid,

} = livekitSlice.actions





export default livekitSlice.reducer